import { RootState } from '../../store';

export const getHomePhotograph = (store: RootState) => store.home.photograph;
export const getIsLoading = (store: RootState) => store.albums.isLoading;
